// src/hooks/useScrollToTopOnNavigate.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { scrollAppContentToTop } from "../utils/navigation/appScroll";

/**
 * Resets the app's scroll container to the top whenever the route changes.
 *
 * Without this, arriving from a scrolled-down page (the Home feed, the To do
 * list, Results) drops the user part-way into the next page — or at its very
 * bottom, once the browser clamps the old offset to the shorter content.
 *
 * Only `pathname` is watched, so query-string changes (filters, pagination)
 * keep their position, and a URL carrying a hash is left alone so in-page
 * anchors still land where they should.
 *
 * @returns {void}
 */
export function useScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;

    scrollAppContentToTop();
  }, [hash, pathname]);
}

export default useScrollToTopOnNavigate;
